/*
 * Story Theme
 *
 * Use this file to add custom Javascript to Story.  Keeping your custom
 * Javascript in this fill will make it easier to update Story. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function ($) {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("DOMContentLoaded", (event) => {
    initializeSlick();

    // Slick Slider Section Start Here
    function initializeSlick() {
      if ($(window).width() <= 767) {
        $(".section-press .press__slider[data-slider-logo]").slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        });
        $(".text-column-sec .flex").slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        });

        $(".section-icons .grid").slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        });

        // Footer Code Start Here



        // Footer Code Ends Here
      }
    }
    $(window).resize(function () {
      initializeSlick();
    });

    addSellingplanEventListener();
  });

  var slideshowWrapper = document.querySelector(
    ".style-order-tracking-one-time-purchase .slideshow__wrapper"
  );

  // Check if the element exists
  if (slideshowWrapper) {
    // Remove the 'slideshow__wrapper' class
    slideshowWrapper.classList.remove("slideshow__wrapper");
  }
})(jQuery);

function addSellingplanEventListener() {
  const sellingPlanDropdown = document.querySelectorAll(
    '.product__details select[name="selling_plan_dropdown"'
  );
  const sellingPlanRadio = document.querySelectorAll(
    '.product__details input[name="selling_plan"'
  );

  if (!sellingPlanDropdown || !sellingPlanRadio) return;
  sellingPlanDropdown.forEach((sellingPlanSel) => {
    sellingPlanSel.addEventListener("change", (e) => {
      const sellingPlanID = e.target.value;
      sellingPlanRadio.forEach((plan) => {
        if (plan.value === sellingPlanID) {
          plan.click();
        }
      });
    });
  })
}

function replaceRegistrationMark() {
  function replaceInTextNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      // Split the text node value by ®
      var textParts = node.nodeValue.split(/(®)/);

      if (textParts.length > 1) {
        // Create a document fragment to hold the new nodes
        var fragment = document.createDocumentFragment();

        textParts.forEach(function (part) {
          if (part === "®") {
            var supElement = document.createElement("sup");
            supElement.textContent = "®";
            fragment.appendChild(supElement);
          } else {
            fragment.appendChild(document.createTextNode(part));
          }
        });

        // Replace the old text node with the new fragment
        node.parentNode.replaceChild(fragment, node);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // Check if the node is part of the footer icons or exclude certain elements
      if (!isFooterIcon(node)) {
        // Recursively process child nodes
        node.childNodes.forEach(replaceInTextNode);
      }
    }
  }

  // Function to check if the element is a footer icon or should be excluded
  function isFooterIcon(element) {
    // Example: Assuming footer icons have a class "footer-icon"
    return element.classList.contains("footer-icon");
  }

  // Start processing from the body element
  replaceInTextNode(document.body);
}

replaceRegistrationMark();



document.addEventListener("DOMContentLoaded", function() {
  function handleMediaQueryChange(event) {
    if (event.matches) {
      let svg = '<svg xmlns="http://www.w3.org/2000/svg" width="5.991" height="10.568" viewBox="0 0 5.991 10.568"><path id="Path_3271" data-name="Path 3271" d="M-11189.931,237.594l4.931,4.931-4.931,4.931" transform="translate(11190.284 -237.24)" fill="none" stroke="#fff" stroke-width="1"/></svg>';
      $(".site-footer .footer-menus .box h6").each(function () {
        $(this).append(svg);
      });
      $(".site-footer .footer-menus .box1").addClass("active");

      $(".site-footer .footer-menus .box h6").click(function () {
        $(this).siblings("ul").slideToggle();
        $(this).parent().toggleClass("active");
        $(this).parent().siblings().removeClass("active");
        $(this).parent().siblings(".box").find("ul").slideUp();
      });
    }
  }

  // Create a MediaQueryList object
  const mediaQueryList = window.matchMedia("(max-width: 767px)");

  // Initial check
  handleMediaQueryChange(mediaQueryList);

  // Listen for changes in the media query status
  mediaQueryList.addEventListener('change', handleMediaQueryChange);
});